<router-outlet></router-outlet>

@if (spinnerSvc.isLoading()) {
    <div class="spinner-overlay">
        <p-progressSpinner/>
    </div>
}

<p-toast></p-toast>
<p-confirmDialog styleClass="votapp-confirm-dialog"></p-confirmDialog>
